<app-common-modal-form
  header="Ad-hoc Payment Reminders"
  icon="ic-bell-20"
  [isCustomFooter]="true"
  (close)="close()"
>
  <div class="body-container" [formGroup]="form">
    <div class="d-flex flex-column justify-content-between gap-24">
      <div class="d-flex flex-column gap-24">
        <app-radio
          formControlName="sendBy"
          label="Send by"
          [options]="sendByOptions"
          (changed)="onSendByChanged($event)"
        />

        <div class="payment d-flex flex-column gap-12 p-4 bg-gray-100">
          <section class="payment-group">
            <div class="payment-group-row">
              <h3 class="title">Debt</h3>
              <div
                appCopy
                class="value marked"
              >
                {{ company?.companyDebt?.amountOwing ?? 0 | currency: '$' }}
              </div>
            </div>

            <div class="payment-group-row">
              <div class="title">Debt Last Updated</div>
              <div class="value">{{ currentDate | date: 'dd/MM/yyyy HH:mm' }}</div>
            </div>

            @if (isSendDebtReminder) {
              <div class="payment-group-row">
                <div class="title">Last debt reminder was sent on</div>
                <div class="value">{{ currentDate | date: 'dd/MM/yyyy HH:mm' }}</div>
              </div>
            }
          </section>

          <app-divider/>

          <section class="payment-group">
            <div class="payment-group-row">
              <h3 class="title">BPAY Code</h3>
              <div class="value" appCopy></div>
            </div>

            <div class="payment-group-row">
              <div class="title">Biller Code</div>
              <div class="value" appCopy>17301</div>
            </div>

            <div class="payment-group-row">
              <div class="title">Reference</div>
              <div class="value" appCopy>{{ company?.bPayReference | bPayCodeFormat }}</div>
            </div>
          </section>

          @if (company?.postBillpay) {
            <app-divider/>

            <section class="payment-group">
              <div class="payment-group-row">
                <h3 class="title">POST Billpay</h3>
                <div class="value" appCopy></div>
              </div>

              <div class="payment-group-row">
                <div class="title">Biller Code</div>
                <div class="value" appCopy>8929</div>
              </div>

              <div class="payment-group-row">
                <div class="title">Reference</div>
                <div class="value" appCopy>{{ company?.postBillpay | bPayCodeFormat }}</div>
              </div>
            </section>
          }
        </div>
      </div>

      @if (form.controls.sendBy.value === SendOption.Email) {
        <div class="d-flex flex-column gap-12">
          <app-yes-no-control
            formControlName="attachInvoice"
            label="Attach Payslip"
          />

          <div class="form-group">
            <app-contacts-select
              label="Recipient"
              formControlName="recipientEmails"
              [entityId]="company?.entityId ?? null"
              [contacts]="contacts"
              (select)="onRecipientEmailChanged($event)"
              (contactCreated)="onContactCreated($event, form.controls.recipientEmails); onRecipientEmailChanged($event)"
            />

            @if (form.controls.recipientEmails.valid && (!selectedRecipientEmailContact?.email || !isEmailContactValid)) {
              <div class="color-red font-size-12 font-weight-400 line-height-16">
                {{ contactWithEmailRequiredMessage }}
              </div>
            }
          </div>
        </div>
      } @else {
        <div class="form-group">
          <app-contacts-select
            label="Recipient"
            placeholder="Select recipient"
            formControlName="recipientPhones"
            [entityId]="company?.entityId ?? null"
            [contacts]="contacts"
            (select)="onRecipientPhoneChanged($event)"
            (contactCreated)="onContactCreated($event, form.controls.recipientPhones);onRecipientPhoneChanged($event)"
          />

          @if (form.controls.recipientPhones.valid && (!selectedRecipientPhonesContact?.phone || !isPhoneContactValid)) {
            <div class="color-red font-size-12 font-weight-400 line-height-16">
              {{ contactWithPhoneRequiredMessage }}
            </div>
          }
        </div>
      }
    </div>

    <div class="preview-container">
      @if (!isLoading) {
        @if (form.controls.sendBy.value === SendOption.Email && emailHtmlContent()) {
          <div class="font-weight-normal">Subject: {{ emailTemplate.subjectTemplate }}</div>
          <div class="preview-dashboard bg-gray-100" [class.annual-height]="isAnnualReminder">
            <app-shadow-dom-viewer [htmlContent]="emailHtmlContent()"/>
          </div>
        } @else if (form.controls.sendBy.value == SendOption.Sms && smsHtmlContent()) {
          <div class="font-weight-normal">SMS Preview</div>
          <div class="preview-dashboard bg-gray-100 p-3 h-auto">
            <div [innerHtml]="smsHtmlContent()"></div>
          </div>
        }
      } @else {
        <ngx-skeleton-loader count="2" appearance="line"/>
        <div class="d-flex gap-24">
          <ngx-skeleton-loader style="width: 50%" count="3" appearance="line"/>
          <ngx-skeleton-loader style="width: 50%" count="3" appearance="line"/>
        </div>
        <ngx-skeleton-loader count="2" appearance="line"/>
        <div class="d-flex gap-24">
          <ngx-skeleton-loader style="width: 50%" count="3" appearance="line"/>
          <ngx-skeleton-loader style="width: 50%" count="3" appearance="line"/>
        </div>
        <ngx-skeleton-loader count="2" appearance="line"/>
      }
    </div>
  </div>

  <div class="custom-footer d-flex gap-12">
    <button
      type="button"
      class="btn btn-primary d-flex align-items-center gap-2"
      [disabled]="form.invalid || isLoading"
      (click)="sendReminder()"
    >
      <i class="icon ic-bell-20"></i>
      <span>Send Reminder</span>
    </button>

    <app-divider [vertical]="true"/>

    @if (company?.postBillpay) {
      <a
        class="btn btn-secondary d-flex align-items-center gap-2"
        target="_blank"
        [routerLink]="isPaymentUrlLoading ? null : paymentUrl"
        [class.btn-loading]="isPaymentUrlLoading"
      >
        <i class="icon ic-debt-20"></i>
        <span>Pay Debt</span>
      </a>
    }

    <button
      type="button"
      class="btn btn-secondary d-flex align-items-center gap-2"
      [disabled]="isLoading"
      (click)="close()"
    >
      Cancel
    </button>
  </div>
</app-common-modal-form>
